
const dev = process.env.NODE_ENV === 'development'

//const baseUrl    = dev ? 'http://192.168.3.160' : 'http://3.35.125.174';
//const apiUrl     = baseUrl + ':3500/';
//const domain     = dev ? 'http://localhost:3000/' : 'http://3.35.125.174/';
//const adminUrl   = dev ? 'http://localhost:4000/' : 'http://3.35.125.174/admin/';
//const resourcUrl = dev ? baseUrl + '/uploads/' : 'http://3.35.125.174/uploads/';

const baseUrl    = 'https://dal-kom.com';
const apiUrl     = 'https://api.dal-kom.com/';
const domain     = dev ? 'http://localhost:3000/' : 'https://dal-kom.com/';
const adminUrl   = dev ? 'http://localhost:4000/' : 'https://dal-kom.com/admin/';
const resourcUrl = 'https://dal-kom.com/uploads/';


export default {
  dev,
  baseUrl,
  apiBasicUrl:  apiUrl,
  resourcUrl,
  domain,
  adminUrl,
  
  kakaoJavaScript:    'd5624ba31c0727730e8903c64d53ec02', //'91f16d20b249d17ae1e0dfb0df96ce0b',
  naverClientID:      'kwJiZnvxSg3UWxqqQgaD',
  naverClientSecret:  'aU0M35XsMk',

  dalkom_link:  'https://docs.google.com/forms/d/1Wlosw5nxolrIdYoDr4eYPbM0MmQK2ZHRS9jSC1zD9es/viewform?edit_requested=true'
};